import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { Fragment } from "react";
import { useTranslation } from "@i18n";
import Markdown from "markdown-to-jsx";
import stl from "./PaymentInfoV2.module.css";
import PriceDetailsShimmer from "@/pages/checkout/components/PaymentInfo/PriceDetailsShimmer";
import { CDN_LINK } from "@globalConfig";
import { twMerge } from "tailwind-merge";
import ExpandableWarrantySelector from "@/pages/checkout/components/PaymentInfo/ExpandableWarrantySelector";
import WarrantyCollapsedHeader from "@/pages/checkout/components/PaymentInfo/WarrantyCollapsedHeader";
import { trackEvents } from "@/common/events/events";
// ─── Section Components ───────────────────────────────────────────────────────

var CarHeaderSection = function CarHeaderSection(_ref) {
  var _section$items;
  var section = _ref.section;
  var item = (_section$items = section.items) === null || _section$items === void 0 ? void 0 : _section$items[0];
  if (!item) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.ImageName
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.imgContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: item.car_image
  })), /*#__PURE__*/React.createElement("div", {
    id: "checkout-payment-title-container",
    className: stl.titleContainer
  }, /*#__PURE__*/React.createElement("strong", {
    id: "checkout-payment-car-title"
  }, item.car_title)));
};
var MetaSection = function MetaSection(_ref2) {
  var _section$items2;
  var section = _ref2.section,
    showOrderNumber = _ref2.showOrderNumber,
    isFinance = _ref2.isFinance,
    showRemainingData = _ref2.showRemainingData;
  var item = (_section$items2 = section.items) === null || _section$items2 === void 0 ? void 0 : _section$items2[0];
  if (!showOrderNumber || isFinance || showRemainingData || !(item !== null && item !== void 0 && item.order_id)) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.flxMeS
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.label
  }, item.title || section.section_title), /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_order-id",
    className: stl.orderId
  }, item.order_id));
};
var PriceRowSection = function PriceRowSection(_ref3) {
  var _section$items3, _item$note_info;
  var section = _ref3.section,
    onClickInfoIcon = _ref3.onClickInfoIcon;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var item = (_section$items3 = section.items) === null || _section$items3 === void 0 ? void 0 : _section$items3[0];
  if (!item || item.hide) return null;
  var showNote = item.show_note && item.note_info;
  return /*#__PURE__*/React.createElement("div", {
    id: "checkout-".concat(section.key, "-row"),
    className: twMerge(stl.flx, item.is_discount ? [stl.discount].join(" ") : "")
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex items-center gap-1 flex-wrap"
  }, item.title, item.style && /*#__PURE__*/React.createElement(Markdown, {
    className: "font-medium text-xs [&>strong]:font-bold px-1 py-0.5 rounded",
    style: {
      color: item.style.text_color,
      backgroundColor: item.style.background_color
    }
  }, item.style.label), item.value_desc && /*#__PURE__*/React.createElement("p", {
    className: "w-full text-[#6c7a8d] text-[10px] leading-4 mt-0"
  }, item.value_desc)), showNote ? /*#__PURE__*/React.createElement("div", {
    className: "flex gap-[9px] w-[150px] items-center justify-end cursor-pointer hasEvents",
    onClick: function onClick() {
      return onClickInfoIcon === null || onClickInfoIcon === void 0 ? void 0 : onClickInfoIcon();
    }
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-[#6D7A8D] text-sm font-bold leading-6"
  }, (_item$note_info = item.note_info) === null || _item$note_info === void 0 ? void 0 : _item$note_info.sub_title), /*#__PURE__*/React.createElement("img", {
    className: "hasEvents cursor-pointer",
    src: CDN_LINK + "/assets/images/Vector.svg",
    alt: "icon"
  })) : item.is_free ? /*#__PURE__*/React.createElement("strong", {
    className: "!text-[#00b362] font-bold text-xl whitespace-nowrap shrink-0 flex flex-col items-end gap-1"
  }, item.formatted_value, item.formatted_old_value && /*#__PURE__*/React.createElement(Markdown, {
    className: "!text-[#6c7a8d] underline [text-underline-offset:-40%] [text-decoration-skip-ink:none] text-base leading-[18px] font-bold [&_p]:font-bold [&_*]:font-bold [&_del]:[text-decoration:none]"
  }, String(item.formatted_old_value))) : section.key === 'referral_discount' ? /*#__PURE__*/React.createElement("strong", {
    className: "!text-[#00b362] font-bold !text-[20px] whitespace-nowrap shrink-0"
  }, item.formatted_value) : /*#__PURE__*/React.createElement("strong", {
    className: "whitespace-nowrap shrink-0"
  }, item.formatted_value));
};
var TotalSection = function TotalSection(_ref4) {
  var _section$items4;
  var section = _ref4.section,
    isFinance = _ref4.isFinance,
    showRemainingData = _ref4.showRemainingData;
  var item = (_section$items4 = section.items) === null || _section$items4 === void 0 ? void 0 : _section$items4[0];
  if (showRemainingData || !item || item.hide) return null;
  return /*#__PURE__*/React.createElement("div", {
    id: "precheckout-total-price",
    className: [stl.flx, stl.totalRow, isFinance ? stl.borderBottom : ""].join(" ")
  }, /*#__PURE__*/React.createElement("span", null, item.title), /*#__PURE__*/React.createElement("strong", {
    id: "checkout-total-price",
    className: "whitespace-nowrap shrink-0"
  }, item.formatted_value));
};
var InfoCardSection = function InfoCardSection(_ref5) {
  var _section$items5;
  var section = _ref5.section,
    hideData = _ref5.hideData;
  var item = (_section$items5 = section.items) === null || _section$items5 === void 0 ? void 0 : _section$items5[0];
  if (hideData || !item) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.flx, stl.ArboonRow].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.colFlex
  }, /*#__PURE__*/React.createElement("span", null, item.title), /*#__PURE__*/React.createElement("p", null, item.value_desc2)), /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_arboun-fees",
    className: "whitespace-nowrap shrink-0"
  }, item.formatted_value, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: stl.note
  }, item.value_desc)));
};
var WarrantyListSection = function WarrantyListSection(_ref6) {
  var _section$items6, _item$warranty_items, _header_warranty$styl, _header_warranty$styl2, _header_warranty$styl3, _header_warranty$styl4, _header_warranty$styl5, _header_warranty$styl6, _header_warranty$valu, _header_warranty$old_, _header_warranty$form, _header_warranty$form2, _header_warranty$is_f, _selected$price$origi, _selected$price$origi2;
  var section = _ref6.section,
    showWarrantyWidget = _ref6.showWarrantyWidget,
    onWarrantySelected = _ref6.onWarrantySelected,
    warranty_promo_code = _ref6.warranty_promo_code,
    warrantyEventBase = _ref6.warrantyEventBase;
  var item = (_section$items6 = section.items) === null || _section$items6 === void 0 ? void 0 : _section$items6[0];
  if (!(item !== null && item !== void 0 && (_item$warranty_items = item.warranty_items) !== null && _item$warranty_items !== void 0 && _item$warranty_items.length) && !(item !== null && item !== void 0 && item.header_warranty)) return null;
  var warranty_items = item.warranty_items,
    selected = item.selected,
    header_warranty = item.header_warranty;
  var warrantyData = {
    selected: selected,
    items: (warranty_items !== null && warranty_items !== void 0 ? warranty_items : []).map(function (w) {
      var _w$price$original, _w$price$original_for;
      return {
        id: w.id,
        title: w.title,
        badge: w.badge,
        subtitle: w.subtitle,
        price: {
          current: w.price.current,
          original: (_w$price$original = w.price.original) !== null && _w$price$original !== void 0 ? _w$price$original : 0,
          current_formatted: w.price.current_formatted,
          original_formatted: (_w$price$original_for = w.price.original_formatted) !== null && _w$price$original_for !== void 0 ? _w$price$original_for : ""
        },
        selected: w.selected,
        is_default: w.is_default,
        years: w.years
      };
    })
  };
  var warrantyPriceDetails = header_warranty ? {
    title: (_header_warranty$styl = (_header_warranty$styl2 = header_warranty.style) === null || _header_warranty$styl2 === void 0 ? void 0 : _header_warranty$styl2.label) !== null && _header_warranty$styl !== void 0 ? _header_warranty$styl : "",
    text_color: (_header_warranty$styl3 = (_header_warranty$styl4 = header_warranty.style) === null || _header_warranty$styl4 === void 0 ? void 0 : _header_warranty$styl4.text_color) !== null && _header_warranty$styl3 !== void 0 ? _header_warranty$styl3 : "",
    highlight_background: (_header_warranty$styl5 = (_header_warranty$styl6 = header_warranty.style) === null || _header_warranty$styl6 === void 0 ? void 0 : _header_warranty$styl6.background_color) !== null && _header_warranty$styl5 !== void 0 ? _header_warranty$styl5 : "",
    price: {
      current: (_header_warranty$valu = header_warranty.value) !== null && _header_warranty$valu !== void 0 ? _header_warranty$valu : 0,
      original: (_header_warranty$old_ = header_warranty.old_value) !== null && _header_warranty$old_ !== void 0 ? _header_warranty$old_ : 0,
      current_formatted: (_header_warranty$form = header_warranty.formatted_value) !== null && _header_warranty$form !== void 0 ? _header_warranty$form : "",
      original_formatted: (_header_warranty$form2 = header_warranty.formatted_old_value) !== null && _header_warranty$form2 !== void 0 ? _header_warranty$form2 : ""
    },
    is_free: (_header_warranty$is_f = header_warranty.is_free) !== null && _header_warranty$is_f !== void 0 ? _header_warranty$is_f : header_warranty.value === 0
  } : selected !== null && selected !== void 0 && selected.years_with_kilometers ? {
    title: selected.years_with_kilometers.title,
    text_color: selected.years_with_kilometers.text_color,
    highlight_background: selected.years_with_kilometers.highlight_background,
    price: {
      current: selected.price.current,
      original: (_selected$price$origi = selected.price.original) !== null && _selected$price$origi !== void 0 ? _selected$price$origi : 0,
      current_formatted: selected.price.current_formatted,
      original_formatted: (_selected$price$origi2 = selected.price.original_formatted) !== null && _selected$price$origi2 !== void 0 ? _selected$price$origi2 : ""
    },
    is_free: selected.price.current === 0
  } : null;
  return /*#__PURE__*/React.createElement("div", {
    className: twMerge("my-2 md:mb-5")
  }, showWarrantyWidget ? /*#__PURE__*/React.createElement(ExpandableWarrantySelector, {
    warrantyData: warrantyData,
    warrantyPriceDetails: warrantyPriceDetails,
    warranty_promo_code: warranty_promo_code,
    onListOpened: function onListOpened() {
      return trackEvents('warranty_list_opened', warrantyEventBase !== null && warrantyEventBase !== void 0 ? warrantyEventBase : {});
    },
    onWarrantySelected: (/*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var _warrantyData$items, _warrantyData$items$f;
        var years;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              years = (_warrantyData$items = warrantyData.items) === null || _warrantyData$items === void 0 ? void 0 : (_warrantyData$items$f = _warrantyData$items.find(function (ele) {
                return (ele === null || ele === void 0 ? void 0 : ele.id) == id;
              })) === null || _warrantyData$items$f === void 0 ? void 0 : _warrantyData$items$f.years;
              _context.n = 1;
              return onWarrantySelected === null || onWarrantySelected === void 0 ? void 0 : onWarrantySelected(id);
            case 1:
              trackEvents('warranty_selected', _objectSpread(_objectSpread({}, warrantyEventBase !== null && warrantyEventBase !== void 0 ? warrantyEventBase : {}), {}, {
                selected_warranty: years
              }));
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }())
  }) : warrantyPriceDetails && /*#__PURE__*/React.createElement("div", {
    className: "my-2 me-2"
  }, /*#__PURE__*/React.createElement(WarrantyCollapsedHeader, {
    warrantyPriceDetails: warrantyPriceDetails,
    warranty_promo_code_enabled: warranty_promo_code
  })));
};

// ─── Section Dispatcher ───────────────────────────────────────────────────────

var SectionRenderer = function SectionRenderer(_ref8) {
  var section = _ref8.section,
    showOrderNumber = _ref8.showOrderNumber,
    isFinance = _ref8.isFinance,
    showRemainingData = _ref8.showRemainingData,
    hideData = _ref8.hideData,
    onClickInfoIcon = _ref8.onClickInfoIcon,
    onWarrantySelected = _ref8.onWarrantySelected,
    showWarrantyWidget = _ref8.showWarrantyWidget,
    warranty_promo_code = _ref8.warranty_promo_code,
    warrantyEventBase = _ref8.warrantyEventBase;
  switch (section.type) {
    case 'meta':
      return /*#__PURE__*/React.createElement(MetaSection, {
        section: section,
        showOrderNumber: showOrderNumber,
        isFinance: isFinance,
        showRemainingData: showRemainingData
      });
    case 'price_row':
      return /*#__PURE__*/React.createElement(PriceRowSection, {
        section: section,
        onClickInfoIcon: onClickInfoIcon
      });
    case 'total':
      return /*#__PURE__*/React.createElement(TotalSection, {
        section: section,
        isFinance: isFinance,
        showRemainingData: showRemainingData
      });
    case 'info_card':
      return /*#__PURE__*/React.createElement(InfoCardSection, {
        section: section,
        hideData: hideData
      });
    case 'warranty_list':
      return /*#__PURE__*/React.createElement(WarrantyListSection, {
        section: section,
        showWarrantyWidget: showWarrantyWidget,
        onWarrantySelected: onWarrantySelected,
        warranty_promo_code: warranty_promo_code,
        warrantyEventBase: warrantyEventBase
      });
    default:
      return null;
  }
};

// ─── Main Component ───────────────────────────────────────────────────────────

var PaymentInfoV2 = function PaymentInfoV2(props) {
  var _checkoutOrderV2$sect, _sections$find, _sections$find$items, _sections$find$items$, _props$className;
  var _props$showOrderNumbe = props.showOrderNumber,
    showOrderNumber = _props$showOrderNumbe === void 0 ? true : _props$showOrderNumbe;
  var checkoutOrderV2 = props.checkoutOrderV2,
    hideData = props.hideData,
    isFinance = props.isFinance,
    showRemainingData = props.showRemainingData,
    onClickInfoIcon = props.onClickInfoIcon,
    onWarrantySelected = props.onWarrantySelected,
    _props$showWarrantyWi = props.showWarrantyWidget,
    showWarrantyWidget = _props$showWarrantyWi === void 0 ? false : _props$showWarrantyWi,
    warranty_promo_code = props.warranty_promo_code,
    _props$orderType = props.orderType,
    orderType = _props$orderType === void 0 ? 'cash' : _props$orderType,
    _props$warrantyReferr = props.warrantyReferralLocation,
    warrantyReferralLocation = _props$warrantyReferr === void 0 ? 'checkout' : _props$warrantyReferr;
  var sections = (_checkoutOrderV2$sect = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.sections) !== null && _checkoutOrderV2$sect !== void 0 ? _checkoutOrderV2$sect : [];
  var warrantyEventBase = {
    order_id: (_sections$find = sections.find(function (s) {
      return s.type === 'meta';
    })) === null || _sections$find === void 0 ? void 0 : (_sections$find$items = _sections$find.items) === null || _sections$find$items === void 0 ? void 0 : (_sections$find$items$ = _sections$find$items[0]) === null || _sections$find$items$ === void 0 ? void 0 : _sections$find$items$.order_id,
    referral_location: warrantyReferralLocation,
    order_type: orderType
  };
  var headerSection = sections.find(function (s) {
    return s.type === 'car_header';
  });
  var filteredSections = sections.filter(function (s) {
    if (s.type === 'car_header') return false;
    return true;
  });
  var TAIL_TYPES = new Set(['total', 'info_card']);
  var warrantyIndex = filteredSections.findIndex(function (s) {
    return s.type === 'warranty_list';
  });
  var nonTail = filteredSections.filter(function (s) {
    return !TAIL_TYPES.has(s.type);
  });
  var tail = filteredSections.filter(function (s) {
    return TAIL_TYPES.has(s.type);
  });
  var otherSections = warrantyIndex !== -1 ? [].concat(_toConsumableArray(nonTail.filter(function (s) {
    return s.key !== 'referral_discount' && s.type !== 'warranty_list';
  })), _toConsumableArray(nonTail.filter(function (s) {
    return s.type === 'warranty_list';
  })), _toConsumableArray(nonTail.filter(function (s) {
    return s.key === 'referral_discount';
  })), _toConsumableArray(tail)) : [].concat(_toConsumableArray(nonTail), _toConsumableArray(tail));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "checkout-payment-info-container",
    className: [stl.container, (_props$className = props.className) !== null && _props$className !== void 0 ? _props$className : ""].join(" ")
  }, props.loading ? /*#__PURE__*/React.createElement(PriceDetailsShimmer, null) : /*#__PURE__*/React.createElement(React.Fragment, null, headerSection && /*#__PURE__*/React.createElement(CarHeaderSection, {
    section: headerSection
  }), /*#__PURE__*/React.createElement("div", {
    id: "checkout-payment-row",
    className: stl.genralInfo
  }, otherSections.map(function (section) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: section.key
    }, /*#__PURE__*/React.createElement(SectionRenderer, {
      section: section,
      showOrderNumber: showOrderNumber,
      isFinance: isFinance,
      showRemainingData: showRemainingData,
      hideData: hideData,
      onClickInfoIcon: onClickInfoIcon,
      onWarrantySelected: onWarrantySelected,
      showWarrantyWidget: showWarrantyWidget,
      warranty_promo_code: warranty_promo_code,
      warrantyEventBase: warrantyEventBase
    }));
  })))));
};
export default PaymentInfoV2;